//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/KFObject.js";
let d=[[[0,"AddLeftRailingToggle",1,0],[0,"AddRightRailingToggle",1,0],[0,"AddRiserToggle",1,0],[0,"AddStringerToggle",1,0],[1,"EndElevation",0,"Expression",0],[0,"KfObject",0,"KFObject",0],[0,"NoOfStairs",1,0],[1,"Rise",0,"Expression",0],[1,"Run",0,"Expression",0],[1,"StairNosing",0,"Expression",0],[1,"StairWidth",0,"Expression",0],[1,"StartElevation",0,"Expression",0],[1,"StringerHeight",0,"Expression",0],[1,"StringerWidth",0,"Expression",0],[1,"TotalRise",0,"Expression",0],[1,"TotalRun",0,"Expression",0],[1,"TreadHeight",0,"Expression",0]],[],[]];
SPLM.LineDesigner.StairwayEquipmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.StairwayEquipmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;